import React from "react";
import Page, { PageProps } from "../Page";
import { IPaymentConfirmationPresenter } from "../../../presenter/payment/PaymentConfirmationPresenter";
import PaymentConfirmationDetails from "../../components/payment-confirmation/PaymentConfirmationDetails";
import Header from "../../components/Header";
import Loader from "../../components/Loader";
import { Col, Button, Row } from "antd";
import { UserPreferences } from "../../../common/Constants";
import { FilePdfOutlined } from "@ant-design/icons";

export interface Props extends PageProps {}
export interface State extends IPaymentConfirmationPresenter {}

export default class PaymentConfirmationPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { payment, translate, loaders, shareCode } = this.state;

    return (
      <Page {...this.props}>
        <Header
          title={translate("pages.payment_confirmation")}
          languagePickerVisible={false}
        />
        <div className="content-wrapper">
          <Loader
            loading={loaders.paymentConfirmationLoader}
            children={
              <Row>
                {payment?.id && (
                  <Col
                    sm={24}
                    style={{
                      textAlign: "right",
                      marginBottom: 10,
                      marginTop: 10
                    }}
                    className={"no-print"}
                  >
                    <a
                      key={"file-pdf"}
                      href={`/portal/api/payments/confirmation/${shareCode}/report?language=${UserPreferences.DEFAULT_LANGUAGE.toUpperCase()}`}
                      rel="noopener noreferrer"
                    >
                      <Button className="button-primary">
                        <FilePdfOutlined />
                        {translate("payment_confirmation_page.download")}
                      </Button>
                    </a>
                  </Col>
                )}

                <PaymentConfirmationDetails
                  paymentConfirmationData={payment}
                  translate={translate}
                />
              </Row>
            }
          />
        </div>
      </Page>
    );
  }
}
